import React, { useMemo } from "react";

const testimonials = [
  {
    id: 1,
    name: "Priya S.",
    platform: "Amazon",
    review:
      "These acne patches work overnight. My pimple was visibly smaller by morning",
  },
  {
    id: 2,
    name: "Neha K.",
    platform: "Flipkart",
    review:
      "Best pimple patches I've used. They stay on all night and reduce redness.",
  },
  {
    id: 3,
    name: "Riya M.",
    platform: "Amazon",
    review:
      "Hydrocolloid quality is excellent. Much better than expensive brands.",
  },
  {
    id: 4,
    name: "Anjali P.",
    platform: "Meesho",
    review:
      "Really helped with whiteheads. Will definitely repurchase.",
  },
  {
    id: 5,
    name: "Kavya S.",
    platform: "Amazon",
    review:
      "Invisible on skin and works quickly. Great for emergency breakouts.",
  },
  {
    id: 6,
    name: "Sneha G.",
    platform: "Flipkart",
    review:
      "Very impressed with the quality. Removes pimple gunk overnight.",
  },
  {
    id: 7,
    name: "Pooja R.",
    platform: "Amazon",
    review:
      "Packaging was great and patches stick really well.",
  },
  {
    id: 8,
    name: "Aditi J.",
    platform: "Meesho",
    review:
      "Helped me stop picking at pimples and prevented marks.",
  },
  {
    id: 9,
    name: "Megha T.",
    platform: "Amazon",
    review:
      "Noticeable results within hours. Highly recommended.",
  },
  {
    id: 10,
    name: "Nisha B.",
    platform: "Flipkart",
    review:
      "Comfortable to wear and almost invisible during the day.",
  },
  {
    id: 11,
    name: "Komal A.",
    platform: "Amazon",
    review:
      "One of the best skincare purchases I've made this year.",
  },
  {
    id: 12,
    name: "Tanya S.",
    platform: "Amazon",
    review:
      "Worked exactly as advertised. Fast results.",
  },
  {
    id: 13,
    name: "Simran P.",
    platform: "Flipkart",
    review:
      "Love these patches. They're gentle and effective.",
  },
  {
    id: 14,
    name: "Muskan K.",
    platform: "Meesho",
    review:
      "Perfect for active acne. Great value for money.",
  },
  {
    id: 15,
    name: "Isha V.",
    platform: "Amazon",
    review:
      "Reduces swelling and redness quickly.",
  },
  {
    id: 16,
    name: "Ritu M.",
    platform: "Flipkart",
    review:
      "Very satisfied. Already ordered another pack.",
  },
  {
    id: 17,
    name: "Divya N.",
    platform: "Amazon",
    review:
      "The best acne patches available in this price range.",
  },
  {
    id: 18,
    name: "Shreya A.",
    platform: "Meesho",
    review:
      "Easy to use and very effective.",
  },
  {
    id: 19,
    name: "Aarushi D.",
    platform: "Amazon",
    review:
      "Visible improvement after the first use.",
  },
  {
    id: 20,
    name: "Khushi T.",
    platform: "Flipkart",
    review:
      "Highly recommend for anyone struggling with acne.",
  },
];

function shuffleArray(array) {
  const arr = [...array];

  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));

    [arr[i], arr[j]] = [arr[j], arr[i]];
  }

  return arr;
}

export default function Testimonials() {
  const shuffledTestimonials = useMemo(
    () => shuffleArray(testimonials),
    []
  );

  return (
    <section className="py-10 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto mb-12 px-4">
        <div className="text-center">
          

          <h2 className="mt-3 text-3xl md:text-5xl font-bold text-gray-900">
            Loved By Thousands Of Customers
          </h2>

          <p className="my-2 mb-6 mx-0 text-gray-600 text-xs md:text-lg">
            Verified reviews from Amazon, Flipkart and Meesho customers.
          </p>

          <div className="flex justify-center gap-2 sm:gap-10 mt-2 sm:mt-8 flex-wrap text-black text-pink-600">
            <div>
              <h3 className="text-xl sm:text-3xl font-bold ">4.8★</h3>
              <p className="text-sm text-gray-500">Average Rating</p>
            </div>

            <div>
              <h3 className="text-xl sm:text-3xl font-bold">125K+</h3>
              <p className="text-sm text-gray-500">Orders Delivered</p>
            </div>

            <div>
              <h3 className="text-xl sm:text-3xl font-bold">116K+</h3>
              <p className="text-sm text-gray-500">Happy Customers</p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative">
      <div className="text-center">
        <p className="text-black pb-4 font-semibold tracking-widest uppercase">
            Customer Reviews
          </p>
        </div>
        <div
          className="flex gap-2 sm:gap-4 animate-marquee"
          style={{
            width: "max-content",
          }}
        >
          {[...shuffledTestimonials, ...shuffledTestimonials].map(
            (item, index) => (
              <div
                key={`${item.id}-${index}`}
                className="
                  h-[120px]
                  w-[240px]

                  sm:min-w-[360px]
                  sm:max-w-[360px]
                  sm:h-[240px]
                  bg-white
                  sm:rounded-2xl
                  sm:p-4
                  rounded-xl
                  p-2
                  shadow-sm
                  border
                  border-gray-100
                  flex
                  flex-col
                  hover:shadow-lg
                  transition-all
                  duration-300
                "
              >
                <div className="text-yellow-400 text-lg sm:mb-4">
                  ★★★★★
                </div>

                <div className="w-60 sm:w-80">
                  <p className="text-gray-700 leading-relaxed text-balance line-clamp-4 text-sm sm:text-base">
                    "{item.review}"
                  </p>
                </div>

                <div className="flex justify-between items-center pt-2 sm:pt-4 border-t border-gray-100">
                  <div>
                    <h4 className="text-sm sm:text-base font-semibold text-gray-900">
                      {item.name}
                    </h4>

                    <p className="text-xs sm:text-sm text-gray-500">
                      Verified Buyer
                    </p>
                  </div>

                  <span className="px-3 py-1 rounded-full bg-pink-100 text-pink-700 text-xs font-medium">
                    {item.platform}
                  </span>
                </div>
              </div>
            )
          )}
        </div>
      </div>

      <style jsx>{`
        .animate-marquee {
          animation: marquee 140s linear infinite;
        }

        .animate-marquee:hover {
          animation-play-state: paused;
        }

        @keyframes marquee {
          from {
            transform: translateX(0);
          }

          to {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>
  );
}